import { memo } from 'react';

import { ACTION_TYPES } from 'ui/actions/action-config';
import { JourneyIconButton } from 'ui/journey-builder/node-types/common';
import { NodeContainer } from 'ui/journey-builder/node-types/node-container';
import { JourneyNode } from 'ui/journey-builder/node-types/types';

const ACTION_TYPE = ACTION_TYPES.journey_branch;

export const Node = memo((node: JourneyNode<typeof ACTION_TYPE>) => {
  return (
    <NodeContainer node={node}>
      <JourneyIconButton node={node} color="teal100" isSelectable />
    </NodeContainer>
  );
});
